import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useState,
} from "react";
import { Step, TourContextInterface } from "../models/tour.model";

const TourContext = createContext<TourContextInterface>({
  handleSetStep: (steps: Step[]) => {},
  steps: [] as Step[],
  handleGetStep: (step: Step[], curr: Step) => {},
  handletSetGetStep: (f: (step: Step[], curr: Step) => void) => {}
});

export const useTourContext = () => useContext(TourContext);

export const TourProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [steps, setSteps] = useState<Step[]>([]);
  const [getStep, handletSetGetStep] = useState<(step: Step[], curr: Step) => void>();

  return (
    <TourContext.Provider
      value={{
        steps: steps,
        handleSetStep: setSteps,
        handletSetGetStep: handletSetGetStep,
        handleGetStep: getStep!
      }}
    >
      {children}
    </TourContext.Provider>
  );
};
